var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "atoms/icon/title/leaderboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atoms/icon/title/leaderboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(2.000000, 3.000000)",
    stroke: "#75593A",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76317618,2 C7.75757576,2.10156687 7.75757576,2.20621153 7.75757576,2.31393397 C7.75757576,14.2865137 11.4482553,24 15.9985999,24 C20.5489445,24 24.2424242,14.2865137 24.2424242,2.31393397 C24.2424242,2.20621153 24.239624,2.10156687 24.239624,2 L7.76317618,2 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51677282,19 C5.51677282,19 6.47082288,17.5921977 6.47082288,15.1301363 C6.47082288,12.6680749 0,8.56570096 0,4.23081665 C0,-0.100882589 3.36655729,-0.237840727 4.42725343,0.131627738 C5.70124172,0.571167807 6.78787879,1.88978802 6.78787879,1.88978802",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.728894,19 C30.728894,19 31.6829441,17.5921977 31.6829441,15.1301363 C31.6829441,12.6680749 25.2121212,8.56570096 25.2121212,4.23081665 C25.2121212,-0.100882589 28.5786785,-0.237840727 29.6393746,0.131627738 C30.9133629,0.571167807 32,1.88978802 32,1.88978802",
    id: "Stroke-3",
    transform: "translate(28.606061, 9.500000) scale(-1, 1) translate(-28.606061, -9.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2727273,30 C22.5984149,27.1291718 20.1249417,25 17.1531935,25 L14.8497902,25 C11.8750583,25 9.3986014,27.1291718 8.72727273,30 L23.2727273,30 Z",
    id: "Stroke-7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyIcon);
export default __webpack_public_path__ + "static/media/trophyIcon.e5896ef4bb2fc401a0df185102743257.svg";
export { ForwardRef as ReactComponent };